var cbs = [], 
	data;
module.exports = function(cb) {
	if(cbs) cbs.push(cb);
	else cb(data);
}
require.ensure([], function(require) {
	data = require("!!../../../node_modules/babel-loader/lib/index.js!./index.js");
	var callbacks = cbs;
	cbs = null;
	for(var i = 0, l = callbacks.length; i < l; i++) {
		callbacks[i](data);
	}
}, "tabs");


//////////////////
// WEBPACK FOOTER
// ./~/bundle-loader?name=tabs!./src/web-components/tabs/index.js
// module id = 92
// module chunks = 6